<template>
	<screen class="min-donation-view" type="cerulean">
		<template slot="header">
			<ui-header type="light" @click="onBack" :hideButton="onboarding">
				<h2 slot="title">Set Your Whole Dollar Roundup</h2>
				When a transaction ends on the Whole Dollar ($1.00, $2.00, etc),
				choose the amount we should round up!
			</ui-header>
		</template>
		<form v-on:submit.prevent="onSubmit">
			<label>
				<ul class="segmented-control">
					<li
						v-for="option in options"
						:key="option"
						class="segmented-control__item"
					>
						<input
							class="segmented-control__input"
							type="radio"
							:value="option"
							v-model="wholeDollar"
							name="option"
							:id="'option-' + option"
						/>
						<label
							class="segmented-control__label"
							:for="'option-' + option"
							>${{ (option / 100).toFixed(2) }}</label
						>
					</li>
				</ul>
			</label>
			<label>
				<ui-button
					native-type="submit"
					color="white"
					:loading="isLoading"
					>Save Amount</ui-button
				>
			</label>
		</form>
	</screen>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UiHeader from '../../ui/Header'
import UiButton from '../../ui/Button'
import Screen from '../../ui/Screen'
import { getUrlParams } from '../../utilities'

export default {
	name: 'min-donation-view',
	components: { Screen, UiHeader, UiButton },
	data() {
		return {
			options: [0, 25, 50, 75, 100],
			wholeDollar: 50,
			isLoading: false,
			onboarding: false
		}
	},
	computed: {
		...mapGetters(['user'])
	},
	methods: {
		...mapActions(['updateUser']),
		onSubmit() {
			this.isLoading = true
			window.analytics.track('set_whole_dollar_amount', {
				amount: this.wholeDollar
			})
			const user = {
				whole_transaction_amount: this.wholeDollar,
				minimum_donation: this.user.minimum_donation,
				email: this.user.email,
				phont: this.user.phone
			}
			this.updateUser(user)
				.then(() => {
					this.isLoading = false
					this.$swal(
						'Success',
						'Your Whole Dollar RoundUp has been set! Now your Whole Dollar Transactions will donate $' +
							(this.wholeDollar / 100).toFixed(2) +
							'!'
					).then(() =>
						this.navigate(
							{ name: 'home' },
							this.onboarding ? 'forward' : 'back'
						)
					)
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		},
		onBack() {
			this.navigate({ name: 'home' }, 'back')
		}
	},
	mounted() {
		this.wholeDollar = this.user.whole_transaction_amount
		const params = getUrlParams(window.location.href)
		this.onboarding = params.onboarding
	}
}
</script>

<style lang="scss">
.body {
	padding-left: 20px;
	padding-right: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}
.segmented-control {
	background: $navy;
	color: #fff;
	display: flex;
	width: 100%;
	margin-top: 20px;
	margin-bottom: 0px;
	padding: 0;
	border-radius: 25px;
	.segmented-control__item {
		flex-grow: 1;
		flex-basis: 0;
		margin: 0;
		padding: 0;
		list-style-type: none;
	}
	.segmented-control__input {
		position: absolute;
		visibility: hidden;
	}
	.segmented-control__label {
		display: block;
		padding: 15px 10px;
		text-align: center;
		cursor: pointer;
		border-radius: 25px;
		font-weight: bold;
		&:hover {
			background: $navy-highlight;
			color: $white;
		}
	}
	.segmented-control__input:checked + .segmented-control__label {
		background: $white;
	}
}
</style>
